__turbopack_context__.v({
  "toggleTheme": "ThemeToggle-module-scss-module__uJIBHq__toggleTheme",
  "toggleThemeButton": "ThemeToggle-module-scss-module__uJIBHq__toggleThemeButton",
  "toggleThemeSmall": "ThemeToggle-module-scss-module__uJIBHq__toggleThemeSmall",
});
